import SearchGroup from './containers/search_group/SearchGroup';
import './index.less';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'dva';
import { message } from 'antd';
import HandleTabel from './containers/handle_tabel/TablePage';
import TestPage from './containers/handle_tabel/TestPage';

const DgtTest = () => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [inputList, setInputList] = useState([]);
  const [versonVal, setVersonVal] = useState([]);
  const [outList, setOutList] = useState([]);
  const inputFormRef = useRef();
  // 获取决策图列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'dgtTest/getGraphTable',
      payload: {},
      callback: (res) => {
        let result = [];
        res.forEach((item) => {
          result.push({ name: item.name, value: item.code });
        });
        setOptions(result);
      },
    });
  }, [dispatch]);
  const handleSearch = (Val) => {
    dispatch({
      type: 'dgtTest/getSearch',
      payload: {
        values: {
          ...Val,
        },
      },
      callback: (d) => {
        console.log(d);
        if (JSON.stringify(d) === '[]') {
          message.warning('当前用户没有测试成功记录，请先执行测试');
        }
      },
    });
  };

  const handleclick = (val) => {
    setVersonVal(val);
    dispatch({
      type: 'dgtTest/getGraphInputList',
      payload: {
        values: {
          // strategyCode: val?.strategyCode,
          ...val,
        },
      },
      callback: (d) => {
        if (!d?.code) {
          message.success('查询成功');
        }
        setInputList(d);
      },
    });
  };

  const handleVersion = (val) => {
    setVersonVal(val);
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const handleTest = (val) => {
    let arr = [];
    for (let key in val) {
      arr.push({ id: key, value: val[key] });
    }
    setOutList(arr);
  };

  // 清空输入项
  const resetInput = () => {
    inputFormRef.current.hanleReset();
  };

  return (
    <div className="re">
      <div className="contain">
        <SearchGroup
          options={options}
          handleSearch={(Val) => handleSearch(Val)}
          onClick={handleclick}
          onVersion={handleVersion}
          resetInput={resetInput}
        />
        {/* <footer>
          {run ? (
            <>
              <span className="run"></span>运行中
            </>
          ) : (
            <>
              <span className="stop"></span>未运行
            </>
          )}
        </footer> */}
        {/* <div>{showTable && <TablePage tableData={tableData} />}</div> */}

        <HandleTabel
          cRef={inputFormRef}
          inputList={inputList}
          versonVal={versonVal}
          handleTest={handleTest}
        />
        <p className="dri_space"></p>
        <TestPage outList={outList} />
      </div>
    </div>
  );
};

export default DgtTest;
